const MS_PER_WEEK = 7 * 24 * 60 * 60 * 1000;

/**
 * Дата создания в ISO попадает в интервал [now − windowMs, now].
 * @kind helper
 *
 * @param isoToCompare - Дата события в ISO формате
 * @param windowMs - Интервал в миллисекундах
 * @returns true, если дата создания в интервале [now − windowMs, now], false в противном случае
 */
export function withinLastMs(isoToCompare: string, windowMs: number = MS_PER_WEEK): boolean {
    const dateToCompare = new Date(isoToCompare).getTime();

    if (Number.isNaN(dateToCompare)) {
        return false;
    }

    const now = Date.now();

    if (dateToCompare > now) {
        return false;
    }

    return now - dateToCompare <= windowMs;
}
